module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69305/img/content-remix-post-publish/content-remix-fr.png"